import { Injectable } from '@angular/core';
import { LoginService } from './login/login.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';


@Injectable()
export class AuthService {

  constructor(private _loginService: LoginService) { }

  public isAuthenticated(): boolean {
    var token = Cookie.get('token');
    return !token;
  }
}



// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/auth.service.ts